import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthQuery } from '#lib/hooks/use-auth-query.js';
import { getAuthHeader } from '#lib/hooks/use-auth.jsx';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';
import toast from 'react-hot-toast';

async function fetchTemplates(type = '') {
    const authHeaders = await getAuthHeader();
    const response = await fetchAndParse(`${API_URL}/p/templates?type=${type}`, {
        method: 'GET',
        headers: { ...jsonHeaders, ...authHeaders }
    });
    return response;
}

async function getList(type, authHeaders) {
    // enable query param count to get a list of { name, count }
    const response = await fetchAndParse(`${API_URL}/p/templates?type=${type}&count=true`, {
        method: 'GET',
        headers: { ...jsonHeaders, ...authHeaders }
    });
    return response;
}

async function saveTemplate(body, authHeaders) {
    const response = await fetchAndParse(`${API_URL}/p/templates`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(body)
    });
    return response;
}

async function confirmSaveTemplate(data, authHeaders) {
    if (!data) return 'No data';
    // controllo se ci sono templates duplicati
    const { results } = await getList(data.type, authHeaders);

    // se duplicato
    if (results.some((el) => el === data.title)) {
        let i = 1;
        let newTitle = data.title;

        // cerco il prossimo nome
        do newTitle = [data.title, i++].join(' ');
        while (results.includes(newTitle));

        // se rifiuta nuovo nome lancio errore
        if (!confirm(_t.edit.duplicateTemplatePrompt(newTitle))) return { message: 'SKIP_MUTATION', ok: false };

        data.title = newTitle;
    }

    return saveTemplate(data, authHeaders);
}

async function deleteTemplate(body, authHeaders) {
    const response = await fetchAndParse(`${API_URL}/p/templates`, {
        method: 'DELETE',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(body)
    });
    return response;
}

async function modifyTemplate(body, authHeaders) {
    const response = await fetchAndParse(`${API_URL}/p/templates`, {
        method: 'PUT',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(body)
    });
    return response;
}

export function useTemplates(type) {
    const { data, ...queryProps } = useAuthQuery({
        queryKey: ['templates'],
        queryFn: () => fetchTemplates(type),
        refetchOnWindowFocus: false
    });

    const addTemplate = useAuthMutation({
        mutationFn: confirmSaveTemplate,
        mutationKey: ['templates'],
        onSuccess: (res) => {
            if (res.message === 'SKIP_MUTATION') return;
            res.ok ? toast.success(_t.global.success()) : toast.error(_t.global.error());
        },
        onError: (e) => {
            toast.error(_t.global.error(e));
        }
    });

    const destroyTemplate = useAuthMutation({
        mutationFn: deleteTemplate,
        mutationKey: ['templates'],
        onSuccess: () => toast.success(_t.global.success()),
        onError: () => toast.error(_t.global.error())
    });

    const updateTemplate = useAuthMutation({
        mutationFn: modifyTemplate,
        mutationKey: ['templates'],
        onSuccess: () => toast.success(_t.global.success()),
        onError: () => toast.error(_t.global.error())
    });

    return {
        templates: data?.results,
        addTemplate,
        destroyTemplate,
        updateTemplate,
        ...queryProps
    };
}
